import { render, staticRenderFns } from "./confirm-sms.vue?vue&type=template&id=86bc67b0&scoped=true&"
import script from "./confirm-sms.vue?vue&type=script&lang=js&"
export * from "./confirm-sms.vue?vue&type=script&lang=js&"
import style0 from "./confirm-sms.vue?vue&type=style&index=0&id=86bc67b0&prod&lang=scss&"
import style1 from "./confirm-sms.vue?vue&type=style&index=1&id=86bc67b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86bc67b0",
  null
  
)

export default component.exports